const ResumeApi2 = [
  {
    id: 1,
    category: "experience",
    year: "Software Developer (2021 - 2022) ",
    title: "Brainstorm Force",
    desc: "Collaborated productively with the product team. Twitter Feed widget and also added multi-account support for Instagramin UAE(Ultimate Addons for Elementor ) plugin. Addressed and fixed complex bugs",
  },
  {
    id: 2,
    category: "experience",
    year: "Web Development(2020 - 2021) ",
    title: "Cortica Web Solutions PVT.LTD",
    desc: "Communicate with the customer to understand the requirements Built web pages according to customers' needs. Host the project on the company server and check domain availability according to customers' needs and make it live. Need to maintain the site. ( Made changes if the customer has some new things to showcase on the live site ).",
  },
  {
    id: 3,
    category: "experience",
    year: "Web Development(2017 - 2020) ",
    title: "Freelancing",
    desc: "Communicate with the customer to understand the requirements Built web pages according to customers' needs.",
    rate: 'Freelancing'
  },
]

export default ResumeApi2
